import React, {useEffect, useState} from "react";
import {Box, Button, FormControl, InputLabel, MenuItem, Select} from "@mui/material"
import {getEmbeddedURL} from "../components/API";
import CircleProgressBar from "../components/DataTable/CircleProgressBar";
import CustomSuccessMessage from "../components/DataTable/CustomSuccessMessage";
import {Constants} from "../components/utils/Constants";
import {connect} from "react-redux";
import {getCustomerAndLocations} from "../redux/Thunk/RoutesThunk";
import {getEmbeddedCphDBUrl} from "../redux/Thunk/AssetsThunk";

let LIFT_ALERTS = "Lift_alert";
let CASES_PER_PAGE = "CPH";
let SERVICE_TIMES_REPORT = "DIOT_SERVICE_TIME";
let ASSET_HISTORY = "asset_history";
function CPHDashboard({getEmbeddedCphDBUrl,cphEmbeddedUrl}) {

    const [embeddedUrl,setEmbeddedUrl] = useState("");
    const [isShowMessage,setShowMessage] = useState(false);
    const [errorType,setErrorType] = useState("success");
    const [message,setMessage] = useState("");
    const [progress,setProgress] = useState(true);

    const [rep, setRep] = React.useState(LIFT_ALERTS);

    useEffect(()=>{
        console.log("CPH Dashboard:"+cphEmbeddedUrl);
       // cphEmbeddedUrl = "";
        getDBEmbeddedUrl(LIFT_ALERTS);
    },[]);

    const handleChange = (event) => {
        setRep(event.target.value);
        getDBEmbeddedUrl(event.target.value);
    };
    let getDBEmbeddedUrl = async (report)=>{
        try {
            setProgress(true);
            let data = {};
            data.appName = 'AMI';
            data.dbId = report;
            data.db = 'dashboard';
            let res = await getEmbeddedCphDBUrl(data);


            if(res && res.error){
                showErrorMessage(res.error.message);
                //setProgress(false);
                //console.log(res.error.message);
                //showSuccessErrorMessage(Constants.ERROR,res.error.message);
            }

            //setEmbeddedUrl(cphEmbeddedUrl);
            setTimeout(()=>{
                setProgress(false);
                //console.log(document.querySelector("div[data-automation-id]"));
                //document.getElementsByClassName("flex-grow")[6].style.transform = "none";
            },2000);
           /* let response = await getEmbeddedURL('AMI', 'CPH', 'dashboard');
            if(response && response.data && response.data.embedUrl && response.data.embedUrl.length>0){
                let cphDBUrl = response.data.embedUrl[0]['embed-url'];
                if(cphDBUrl){
                    console.log(cphDBUrl);
                    setEmbeddedUrl(cphDBUrl);
                    setTimeout(()=>{
                        setProgress(false);
                        console.log(document.querySelector("div[data-automation-id]"));
                        //document.getElementsByClassName("flex-grow")[6].style.transform = "none";
                    },1500);
                }

            }*/
            //console.log(response.data.embedUrl[0]['embed-url']);
        }catch (ex){
            console.log(ex.message);
            showErrorMessage(ex.message);
        }
    }

    let showErrorMessage = (msg)=>{
        setProgress(false);
        cphEmbeddedUrl = "";
        showSuccessErrorMessage(Constants.ERROR,msg);
    }

    let showSuccessErrorMessage = (type,msg)=>{
        setShowMessage(true);
        setMessage(msg);
        setErrorType(type);
    }

  return (
    <>
        <Box sx={{width:"250px"}}>
            <FormControl fullWidth variant="standard">

                <Select value={rep} onChange={handleChange}>
                    <MenuItem value={LIFT_ALERTS}>Lift Alerts</MenuItem>
                    <MenuItem value={CASES_PER_PAGE}>Cases Per Hour</MenuItem>
                    <MenuItem value={SERVICE_TIMES_REPORT}>Service Times</MenuItem>
                    <MenuItem value={ASSET_HISTORY}>Asset History</MenuItem>

                </Select>
            </FormControl>
        </Box>
        {rep === SERVICE_TIMES_REPORT && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                <Button
                    message={"ColumnDefinition"}
                    flag={isShowMessage}
                    onHide={() => { setShowMessage(false) }}
                    sx={(theme) => ({ color: theme.palette.primary.light,fontSize: "12px", fontWeight: 400, textTransform: 'none' })}
                    onClick={() => window.open('/column-definitions', '_blank')}
                >
                    Column Definitions
                </Button>
            </Box>
        )}
      <Box sx={{ marginTop: "20px",width:"100%" }}>
          <CustomSuccessMessage   message={message} type={errorType} flag={isShowMessage} onHide={()=>{setShowMessage(false)}}/>
          <div style={{width:"100%",paddingTop:"5px",border:"1px solid #ede6e6",height:(window.innerHeight-100)}}>
              {progress?<CircleProgressBar />:
                  <iframe id={"iFrame"} style={{border: "0px"}}   src={cphEmbeddedUrl} width="100%" height="100%"
                          onLoadedData={() => {
                              console.log('onload')
                          }} frameBorder="0" allowFullScreen="true" webkitallowfullscreen="true"
                          mozallowfullscreen="true"></iframe>}


          </div>

      </Box>
    </>
  );
}

const mapStateToProps = (state) => {
    return {
        selectedCustomerId: state?.Routes?.selectedCustomer,
        selectedLocationId: state?.Routes?.selectedLocation,
        customerAndLocationsData: state?.Routes?.customerAndLocationsData,
        cphEmbeddedUrl: state?.Assets?.cphEmbeddedUrl,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEmbeddedCphDBUrl: (data) => dispatch(getEmbeddedCphDBUrl(data)),

    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CPHDashboard);
